import Login from "./Login";
import "./auth.css"
import TabRow from "../general/input/TabRow";
import {useState} from "react";
import {useSelector} from "react-redux";
import BusinessPartnerSelect from "./BusinessPartnerSelect";
import OrgSelect from "./OrgSelect";
import SignUpContactForm from "../../newStructure/component/auth/SignUpContactForm";

const LOGIN          = "Login";
const REGISTER       = "Sign Up"

const AuthTab = ({ selected, onHide }) => {

    switch (selected) {
        case LOGIN:
            return <Login onHide={onHide} />;
        case REGISTER:
            return <SignUpContactForm onHide={onHide} />
        default:
            return null;
    }
}

const AuthContainer = (props) => {

    const { session, orgSelect, loading } = useSelector(
        (state) => state.auth
    )

    const loggedIn = session != null;
    const loggedInWithoutBP = session != null && !session.bPartnerID

    const TABS = [LOGIN, REGISTER];

    const [ selected, setSelected ] = useState(LOGIN);

    const onChange = (selected) => {
        setSelected(selected)
    }

    if(orgSelect && !loading) {
        return (
            <div className="auth-container">
                <OrgSelect orgs={orgSelect.orgs} authToken={orgSelect.authToken} />
            </div>
        )
    } else if(!loggedIn) {
        return (
            <div className="auth-container">
                <TabRow tabs={TABS} onChange={onChange} selected={selected}></TabRow>
                <div className="auth-divider"/>
                <AuthTab
                    selected={selected}
                    onHide={props.onHide}
                />
            </div>
        )
    } else if (loggedInWithoutBP) {
        return (
            <div className="auth-container">
                <BusinessPartnerSelect session={session} />
            </div>
        )
    }
}

export default AuthContainer;
